export default "__VITE_ASSET__CYuTZHzQ__"